















































import { Component, Prop, Vue } from "vue-property-decorator";
import DoKoHtmlDialog from "../DoKoHtmlDialog.vue";
import DoKoBtn from "../../../components/controls/DoKoBtn.vue";
import DoKoImgBtn from "../../../components/controls/DoKoImgBtn.vue";

@Component({ components: { DoKoHtmlDialog, DoKoBtn, DoKoImgBtn } })
export default class DoKoRestrictionSoloColor extends Vue {
  selectedType: null | "solo-♣" | "solo-♠" | "solo-♥" | "solo-♦" = null;

  onConfirm() {
    console.log("PLAY", this.selectedType);
    if (this.selectedType !== null) {
      this.$emit("announce-restriction", this.selectedType);
    }
  }

  get types() {
    return [
      {
        v: "solo-♣",
        i: "/img/symbols.svg#symbol-kreuz",
      },
      {
        v: "solo-♠",
        i: "/img/symbols.svg#symbol-pik",
      },
      {
        v: "solo-♥",
        i: "/img/symbols.svg#symbol-herz",
      },
      {
        v: "solo-♦",
        i: "/img/symbols.svg#symbol-karo",
      },
    ];
  }
}
